import { render, staticRenderFns } from "./LeicesterEvent.vue?vue&type=template&id=15f9037d&"
import script from "./LeicesterEvent.vue?vue&type=script&lang=js&"
export * from "./LeicesterEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports